import {
  TOGGLE_SCHEDULE_VIEWING_MODAL,
  RECEIVED_VIEWINGS
} from './actions'
import { CLEAR_AUTH_USER } from '../auth/actions'

const defaultState = {
  viewingRequests: new Map(),
  showScheduleViewingModal: false
}

export default function reducer (state = {
  ...defaultState
}, action) {
  switch (action.type) {
    case CLEAR_AUTH_USER:
      return {
        ...defaultState
      }
    case TOGGLE_SCHEDULE_VIEWING_MODAL:
      return {
        ...state,
        showScheduleViewingModal: action.bool
      }
    case RECEIVED_VIEWINGS:
      return {
        ...state,
        viewingRequests: action.viewingRequests
      }
    default:
      return state
  }
}
